import router from "./index.js";
import { callHandler } from '@/utils/native.js'
import { isAndroidIos, isAndroid } from '@/utils/validate'
import { loginMarkCode } from '@/api/version3/version3.js'
import { vipStatus } from "@/api/Credit/zhijie.js"
import { infoByChannel } from '@/api/Credit/user.js'
//生成16位随机数
function getSecureRandom16() {
  const array = new Uint32Array(4);
  window.crypto.getRandomValues(array);
  return Array.from(array, (dec) => dec.toString(16).padStart(8, "0"))
    .join("")
    .slice(0, 16);
}

//落地页相关页面
let attractTrafficList = [
  "/landPage1",
  "/landPage2",
  "/landPage3",
  "/p",
  "/d",
  "/kuaishou/index.html",
  "/other/thirdpartyredirect/tianxiaxinyong"
];

router.beforeEach(async (to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (!localStorage.getItem("_did")) {
    const secureRandom = getSecureRandom16();
    localStorage.setItem("_did", `${secureRandom}`);
  }
  if(to.path.indexOf('/404err') > -1){
      next()
      return
  }
  if (to.query._channel) {
    localStorage.setItem("_channel", `${to.query._channel}`);
  }
  if (to.query.c) {
    localStorage.setItem("_channel", `channel_${to.query.c}`);
  }
  if (to.query.zc) {
    localStorage.setItem("_channel", `ZJchannel_${to.query.zc}`);
  }
  if (to.query._zhijieChannel) {
    localStorage.setItem("_channel", `${to.query._zhijieChannel}`);
  }


  
  //获取渠道数据(只获取一次) 进入渠道页不需要获取渠道信息
  if(to.path.indexOf('/agreement') == -1&&!['/attractTraffic/third-download'].includes(to.path)){

    let storeChannel = localStorage.getItem('channel_info');
    if(!localStorage.getItem('_channel')){
      next({
          path: '/404err',
      })
      return
    }else if (!storeChannel||((localStorage.getItem('_channel') != JSON.parse(storeChannel).channel))) {
        let channelInfo = await infoByChannel(localStorage.getItem('_channel'))
        if (channelInfo.code != 200 || !channelInfo.data|| parseInt(channelInfo.data.status)==0) {
            next({
                path: '/404err',
            })
            return
        }
        localStorage.setItem('channel_info',JSON.stringify(channelInfo.data) )
    }
  }
  //联登直接进入表单提交
  if (to.query.markCode) {
    localStorage.setItem("_channel", `${to.query._channel}`);
    let markBody = null
    if (to.query.markCode) {
      markBody = await loginMarkCode(to.query.markCode)
    }
    if (markBody.code === 200) {
      localStorage.setItem('token', markBody.data.access_token)
      localStorage.setItem('user_id', markBody.data.userinfo.id)
      localStorage.setItem("phone",  markBody.data.userinfo.phone);

      let _path = '/attractTraffic/only-download'
      next({
        path: _path,
        query: {
          previousPage: '联登进入',
          successType: 1,
          _channel: localStorage.getItem('_channel'),
          _token: localStorage.getItem('token')
        }

      })



    } else {

      next({
        path: '/landPage1',
        query: {
          _channel: localStorage.getItem('_channel'),
        }

      })
    }
    return
  }

  //落地页拦截
  if (attractTrafficList.includes(to.path) || to.path.indexOf("/attractTraffic/") != -1) {


    localStorage.setItem("_package", `${"com.gg.zhijie"}`);

    if (to.query._token) {
      localStorage.setItem("token", `${to.query._token}`);
    }
    if (to.query._zjtoken) {
      localStorage.setItem("token", `${to.query._zjtoken}`);
    }
    if (to.query._user_id) {
      localStorage.setItem("user_id", `${to.query._user_id}`);
    }
   
    next();
  } else if (to.query._channel && to.query._zjtoken) {
    //对方产品跳转我方提现页面和还款详情
    localStorage.setItem("_channel", `${to.query._channel}`);
    localStorage.setItem("token", `${to.query._zjtoken}`);
    localStorage.setItem("user_id", `${to.query._user_id}`);
    localStorage.setItem("_package", `${isAndroid() ? "com.gg.zhijie" : "com.zhijie.gg"}`);
    localStorage.setItem("thirdPartyLogin", to.path);//三方登录
    window.document.documentElement.setAttribute("data-theme", 'zhijie');
    next();
  } else if(to.path.indexOf("/h5version/") != -1){
    if (to.query._channel) {
      localStorage.setItem("_channel", `${to.query._channel}`);
      localStorage.setItem("_package", `${"com.gg.zhijie"}`);
    }
    //登录状态或不需要登录的页面
    if(localStorage.getItem("token")||to.meta.notLogin){
      next();
    }else{
      // 如果不是进入登录页
      next({
        path:'/h5version/login'
      })
    }

  } else if (to.query._channel) {
    localStorage.setItem("_channel", `${to.query._channel}`);
    localStorage.setItem("token", `${to.query._token}`);
    //智借app不包含新闪信表单包 也不包括v3智借
    if (
      !isAndroid() &&
      to.path != "/other/about" &&
      to.path.indexOf("/app/") == -1 &&
      to.path.indexOf("/version2/") == -1 &&
      to.path.indexOf("/version3/") == -1
    ) {
      let vipdata = await vipStatus();
      if (vipdata.data&&vipdata.data.isNature) {
        next("/shenheform");
        return;
      }
    }
    callHandler("getToken", {}).then((data) => {
      let userInfo = JSON.parse(data);
      localStorage.setItem("token", `${userInfo._token}`);
      localStorage.setItem("_did", `${userInfo._did}`);
      localStorage.setItem("_channel", `${userInfo._channel}`);
      localStorage.setItem("user_id", `${userInfo._user_id}`);
      localStorage.setItem("appname", `${userInfo.appname}`);
      localStorage.setItem('appcompany', userInfo.company);
      localStorage.setItem("phone", `${userInfo._phone}`);
      localStorage.setItem("_package", `${userInfo._package}`);
      localStorage.setItem("_os", userInfo._os);
      localStorage.setItem("_ua", userInfo._ua);
      localStorage.setItem("_version", userInfo._version);
      let packageName = "zhijie";

      window.document.documentElement.setAttribute("data-theme", "zhijie");
      next();
    });
  } else {

    next();
  }

});



// WEBPACK FOOTER //
// ./src/router/permission.js